var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 91,
    viewBox: "0 0 150 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.575 17.0065L146.576 17.0114L148.482 24.253C148.482 24.2543 148.483 24.2556 148.483 24.257C148.674 25.0162 148.648 25.8138 148.408 26.559C148.167 27.3055 147.722 27.9695 147.123 28.4754L147.122 28.4762L97.2376 70.6825C95.7149 71.9666 93.8196 72.7267 91.8317 72.8508C91.8299 72.8509 91.8281 72.851 91.8262 72.8511L50.5724 74.9609L49.6351 75.0088L49.6235 75.9472C49.5951 78.2545 48.8351 80.4933 47.453 82.341C46.0712 84.1883 44.1389 85.5495 41.9343 86.2287C41.9337 86.2289 41.9332 86.229 41.9326 86.2292L31.7216 89.3262L31.7208 89.3264C28.9616 90.1657 25.982 89.8747 23.4373 88.5176C20.8927 87.1604 18.9913 84.8483 18.151 82.0895C18.151 82.0894 18.151 82.0893 18.1509 82.0892L2.25592 29.8242L2.25591 29.8241C1.41663 27.0649 1.70757 24.0854 3.06476 21.5407C4.42184 18.9961 6.7339 17.0947 9.49256 16.2545C9.49276 16.2544 9.49296 16.2543 9.49316 16.2543L19.7072 13.1564L19.7082 13.1561C22.4074 12.3342 25.3205 12.5956 27.8302 13.8849C30.3398 15.1743 32.2488 17.3903 33.1524 20.0632L33.5141 21.1331L34.5323 20.6445L73.4836 1.95417C75.2789 1.2064 77.2566 1.01101 79.1639 1.39332L79.1685 1.39422L143.331 13.9439C143.332 13.944 143.332 13.944 143.332 13.9441C144.106 14.097 144.821 14.4654 145.395 15.0071C145.969 15.549 146.378 16.2421 146.575 17.0065Z",
    fill: "#F2EAE2",
    stroke: "#082C4E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.621 20.8213L97.478 34.1121",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1934 44.8648C93.9299 44.8648 97.7696 41.0251 97.7696 36.2886C97.7696 31.5521 93.9299 27.7124 89.1934 27.7124C84.4569 27.7124 80.6172 31.5521 80.6172 36.2886C80.6172 41.0251 84.4569 44.8648 89.1934 44.8648Z",
    fill: "#F2EAE2",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineIcon4);
export default __webpack_public_path__ + "static/media/outline-icon4.06214f3b4fbf2c8f2cc3f0ca161942b7.svg";
export { ForwardRef as ReactComponent };